export default (function (value) {
  return value.toString();
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/toString.js
// module id = ./node_modules/redux-actions/es/utils/toString.js
// module chunks = 6 9 11